import { ArrowRight } from "lucide-react";

export const NAVY = "#0B1120";
export const PANEL = "#141F36";
export const LINE = "#3A4763";
export const AMBER = "#F59E0B";
export const MUTED = "#94A3B8";
export const COLORI = { rosso: "#EF4444", giallo: "#F59E0B", verde: "#34D399" };

export const Kicker = ({ children, color = AMBER }) => (
  <div className="flex items-center gap-3 mb-4">
    <span className="h-[3px] w-8" style={{ background: color }} />
    <span className="text-[0.68rem] sm:text-xs font-semibold uppercase tracking-[0.25em]" style={{ color }}>{children}</span>
  </div>
);

export const Btn = ({ children, onClick, type = "button", disabled, testid, className = "" }) => (
  <button type={type} onClick={onClick} disabled={disabled} data-testid={testid}
    className={`w-full inline-flex items-center justify-center gap-2 bg-[#F59E0B] hover:bg-[#d98a08] active:scale-[0.99] disabled:opacity-60 text-[#0B1120] font-bold text-base sm:text-lg px-6 py-4 rounded-full transition-[background-color,transform] ${className}`}>
    {children} <ArrowRight size={18} />
  </button>
);

export const Card = ({ children, accent = LINE, className = "", testid }) => (
  <div className={`rounded-xl p-5 ${className}`} style={{ background: PANEL, border: `1px solid ${accent}` }} data-testid={testid}>
    {children}
  </div>
);

export const Shell = ({ children }) => (
  <div className="min-h-screen text-white" style={{ background: NAVY, fontFamily: "'Work Sans', sans-serif" }} data-testid="semaforo-page">
    <div className="mx-auto w-full max-w-xl px-5 py-8 sm:py-12">{children}</div>
  </div>
);
